export const Container = ({ children }: { children: React.ReactNode }) => (
  <div
    style={{
      fontWeight: 300,
      fontSize: "14px",
      textAlign: "center",
      margin: "0 auto 15px",
      width: "fit-content",
    }}
  >
    {children}
  </div>
);
